import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { ApiRequest, IAppState } from "../../Common";
import { BugReport, FeatureRequest } from "../Models/Feedback";
import { FeedbackCategory } from "../Constants/feedbackEnums";
import { endpoints } from "..";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";

export interface DeleteActionBase {
  type: FeedbackDeleteActionType;
}

export interface Action<Payload> extends DeleteActionBase {
  payload: Payload | null;
}

export enum FeedbackDeleteActionType {
  SET_FEEDBACK_DETAILS = "FEEDBACK_DELETE_SET_FEEDBACK_DETAILS",
  RESET_LOADING = "FEEDBACK_DELETE_RESET_LOADING",
  SET_LOADING = "FEEDBACK_DELETE_SET_LOADING",
  UPDATE_LOADED_FEEDBACK_DETAILS = "FEEDBACK_DELETE_UPDATE_LOADED_FEEDBACK",
  RESET_LOADED = "FEEDBACK_DELETE_RESET_LOADED",
  SET_ERROR = "FEEDBACK_DELETE_SET_ERROR"
}

const setFeedbackDetails = (
  feedback: FeatureRequest | BugReport | null
): Action<FeatureRequest | BugReport | null> => {
  return {
    type: FeedbackDeleteActionType.SET_FEEDBACK_DETAILS,
    payload: feedback
  };
};

export const setLoading = (): DeleteActionBase => {
  return {
    type: FeedbackDeleteActionType.SET_LOADING
  };
};

export const resetLoading = (): DeleteActionBase => {
  return {
    type: FeedbackDeleteActionType.RESET_LOADING
  };
};

export const resetLoaded = (): DeleteActionBase => {
  return {
    type: FeedbackDeleteActionType.RESET_LOADED
  };
};

export const updateLoadedFeedback = (
  feedback: FeatureRequest | BugReport
): Action<FeatureRequest | BugReport> => {
  return {
    type: FeedbackDeleteActionType.UPDATE_LOADED_FEEDBACK_DETAILS,
    payload: feedback
  };
};

const setError = (status: number, description: string) => {
  return {
    type: FeedbackDeleteActionType.SET_ERROR,
    payload: {
      errorCode: status,
      errorDescription: description
    }
  };
};

export const getFeedbackDetails = (
  code: string
): ThunkAction<Promise<void>, IAppState, {}, Action<any>> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<any> => {
    ApiRequest.fromPath(endpoints.feedback.getByCode(code))
      .withAuthHeader()
      .get()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult) => {
            const category =
              FeedbackCategory[result.payload.category as keyof typeof FeedbackCategory];

            if (category === FeedbackCategory.FeatureRequest) {
              dispatch(setFeedbackDetails(result.payload as FeatureRequest));
            } else {
              dispatch(setFeedbackDetails(result.payload as BugReport));
            }
          },
          (result: ResponseResult) => {
            dispatch(setError(response.status, result.error.message));
          },
          () => {
            dispatch(setError(response.status, "An unknown error has occured"));
          }
        );
      });
  };
};
